module.exports = __webpack_public_path__ + "img/技术需求库banner.52afd2f1.png";